import Hero from "@/components/home/Hero";
import Stats from "@/components/home/Stats";
import Services from "@/components/home/Services";
import WhyChoose from "@/components/home/WhyChoose";
import Destinations from "@/components/home/Destinations";
import HowItWorks from "@/components/home/HowItWorks";
import Testimonials from "@/components/home/Testimonials";
import CtaBanner from "@/components/home/CtaBanner";
import Marquee from "@/components/home/Marquee";

const Home = () => (
  <main data-testid="home-page">
    <Hero />
    <Stats />
    <Services />
    <Marquee />
    <WhyChoose />
    <Destinations />
    <HowItWorks />
    <Testimonials />
    <CtaBanner />
  </main>
);

export default Home;
